import {
  AvailabilityStatusKey,
  SalesChannelKey,
} from "~/constants/product-availability-statuses";

import { SalesPanelStockAvailabilityStatusesExtended } from "./types";

export const getTranslationsByStatusKey = (
  productStockAvailabilityStatuses: SalesPanelStockAvailabilityStatusesExtended,
  statusKey: string | number | undefined,
): string | null => {
  if (typeof statusKey !== "string") {
    return null;
  }

  switch (statusKey) {
    case AvailabilityStatusKey.availableInStore:
      return productStockAvailabilityStatuses.inStock ?? null;
    case AvailabilityStatusKey.lowInStore:
      return productStockAvailabilityStatuses.lowInStock ?? null;
    case AvailabilityStatusKey.soldOutInStore:
      return productStockAvailabilityStatuses.soldOutInStore ?? null;
    case SalesChannelKey.notSoldInStore:
      return productStockAvailabilityStatuses.notSoldInStore ?? null;
    case AvailabilityStatusKey.notAvailableInStore:
      return productStockAvailabilityStatuses.notAvailableInStore ?? null;
    case AvailabilityStatusKey.sizeNotSelected:
      return (
        productStockAvailabilityStatuses?.selectSizeToCheckAvailabilityText ?? null
      );

    default:
      return null;
  }
};
